export default [
  {
    path: 'edit-journal/:state/:journalKey/:id?',
    name: 'edit-journal',
    component: () => import('@/views/journal/components/edit-journal.vue'),
    meta: { title: '编写日报' },
    props: true
  }
]
